/**
 * 日曆打勾圖示（活動 icon）
 * 使用 lucide-react CalendarCheck，意象：已排程／已確認的活動
 * 用於活動交付、建立活動等
 */

import { CalendarCheck } from 'lucide-react';

interface CalendarCheckIconProps {
  /** 尺寸 class，如 'w-14 h-14'、'w-16 h-16' */
  className?: string;
}

export function CalendarCheckIcon({
  className = 'w-14 h-14',
}: CalendarCheckIconProps) {
  return <CalendarCheck className={className} aria-hidden />;
}
